/* ==========================================================================
  main.js
========================================================================== */

"use strict";
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

// Add div to groups
const groups = document.querySelectorAll(
  ".wp-block-group.has-blue-background-color"
);
for (let i = 0; i < groups.length; i++) {
  var div = document.createElement("div");
  let theFirstChild = groups[i].firstChild;

  div.className = "wp-block-group__background";

  groups[i].insertBefore(div, theFirstChild);
}
